import axios from 'axios'
import * as React from 'react'

import Button from '../../components/atoms/Button/Button'
import ImageAsset, { ImageAssetType } from '../../components/atoms/ImageAsset/ImageAsset'
import Logo, { LogoType } from '../../components/atoms/Logo/Logo'
import LimitTextField from '../../components/molecules/LimitTextField/LimitTextField'
import CommonFooter from '../../components/organisms/CommonFooter/CommonFooter'
import * as styles from './InputEmailForPasswordResetPage.css'

class InputEmailForPasswordResetPage extends React.PureComponent<
  {},
  {
    email: string
    isLoading: boolean
    isCompleted: boolean
  }
> {
  public constructor(props: any) {
    super(props)
    this.state = {
      email: '',
      isLoading: false,
      isCompleted: false
    }
  }

  public setEmail(email: string) {
    this.setState({
      email
    })
  }

  public async handleChangePassword() {
    this.setState({
      isLoading: true
    })

    try {
      await axios.post('/api/v1/organizers/password/reset/email', {
        email: this.state.email
      })
      this.setState({
        isCompleted: true
      })
    } catch (e) {
      window.alert('予期せぬエラーが発生しました。管理者に問い合わせてください。')
    } finally {
      this.setState({
        isLoading: false
      })
    }
  }

  public render() {
    return (
      <div className={styles.background}>
        <div className={styles.container}>
          <div className={styles.backgroudImage}>
            <ImageAsset type={ImageAssetType.TOP_VISUAL} />
          </div>
          <div className={styles.mainContent}>
            <div className={styles.titlePart}>
              <div className={styles.logo}>
                <Logo type={LogoType.GRAY} />
              </div>
              <h1 className={styles.title}>パスワードの再設定</h1>
              {this.state.isCompleted ? (
                <p className={styles.text}>再設定用のURLを登録されたメールアドレス宛に送信しました。</p>
              ) : (
                <p className={styles.text}>アカウントに登録されたメールアドレスを入力してください。</p>
              )}
            </div>
            {this.state.isCompleted ? null : (
              <>
                <div className={styles.passwordFormContainer}>
                  <LimitTextField
                    title="メールアドレス"
                    showLimitCount={false}
                    placeholder="メールアドレス"
                    text={this.state.email}
                    handleChange={(e: any) => this.setEmail(e.targetTitle)}
                  />
                </div>
                <div className={styles.button}>
                  <Button handleClick={() => this.handleChangePassword()} isLoading={this.state.isLoading}>
                    次へ
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
        <CommonFooter />
      </div>
    )
  }
}

export default InputEmailForPasswordResetPage
